import React, { useEffect, useState } from "react";
import Card from "olive-react-myoneui/lib/Card";
import { folderIcon } from "../../../constants/icons";
import OffcanvasDocUploads from "./OffcanvasDocUploads";
import ExtDocCard from "./ExtDocCard";
import { getAllExternalDocs } from "../../../../api/afterLogin/externalDocs";
import { useDispatch, useSelector } from "react-redux";
import { setConfigData } from "../../../../reducers/configSlice";
import Button from "olive-react-myoneui/lib/Button";
import { addIcon } from "../../../constants/icons";
import NoItemsInfo from "../NoItemsInfo";

const ExternalCertificates = ({ setHasError }) => {
  const dispatch = useDispatch();
  const learnerData = useSelector((state) => state.user.user);
  const [externalDocDatas, setExternalDocDatas] = useState([]);
  const configData = useSelector((state) => state.config);
  const learner = configData?.session;

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [triggerText, setTriggerText] = useState("");
  const [id, setID] = useState(0);

  const external_docs_list = async () => {
    try {
    const data = JSON.stringify({
      learner_id: learner.id,
    });
    const externalDocData = await getAllExternalDocs(
      data,
      configData.access_token
    );
    setExternalDocDatas(externalDocData);
    } catch (error) {
      setHasError(true);
      console.error(error);
    }
  };

  useEffect(() => {
    external_docs_list();
    dispatch(setConfigData({ success_doc: false }));
  }, [configData.success_doc]);

  dispatch(setConfigData({ externaldoccount: externalDocDatas.length }));
  let externalShow;
  if (configData.has_certificate_document == 1) {
    externalShow = true;
  } else {
    externalShow = externalDocDatas.length > 0 ? true : false;
  }

  return (
    <>
      {externalShow && (
        <Card className="myk__stu-ext_docs-wrapper mb-4">
          <Card.Header className="mb-3">
            <h2>{folderIcon} External Certificates & Documents  <span className="myk__stu-learner-counter">{externalDocDatas.length}</span></h2>
          </Card.Header>
          <Card.Body>
            <div className="myk__stu-external-cert-list">
            {externalDocDatas.length === 0 ? (
              <NoItemsInfo 
                className="myk__stu-empty-doc" 
                title="No External Documents Uploaded Yet!"
                description="External documents will be listed here, once uploaded."
              />
            ) : (
              externalDocDatas.map((doc) => {
                let fileType;
                const extension = doc.ed_filename
                  .split(".")
                  .pop()
                  .toLowerCase();
                if (extension === "pdf") {
                  fileType = "pdf";
                } else if (extension === "doc" || extension === "docx") {
                  fileType = "doc";
                } else {
                  fileType = "image";
                }

                return (
                  <ExtDocCard
                    key={doc.id}
                    className="ext"
                    docName={doc.ed_name}
                    docFileName={doc.ed_filename}
                    uploadedDate={doc.created_date}
                    fileType={fileType}
                    docType={fileType}
                    id={doc.id}
                    show={showOffcanvas}
                    setID={setID}
                    setShow={setShowOffcanvas}
                    setTriggerText={setTriggerText}
                    accessToken={configData.access_token}
                  />
                );
              })
            )}
            </div>
          </Card.Body>
          {configData.has_certificate_document == 1 && (
            <Card.Footer>
              <Button
                variant="outline"
                className="dark btn-add-docment"
                onClick={() => {
                  setShowOffcanvas(true);
                  setTriggerText("Upload your documents");
                }}
              >
                {addIcon} Upload your documents
              </Button>
              <OffcanvasDocUploads
                show={showOffcanvas}
                setShow={setShowOffcanvas}
                triggerText={triggerText}
                accessToken={configData.access_token}
                id={id}
              />
            </Card.Footer>
          )}
        </Card>
      )}
    </>
  );
};

export default ExternalCertificates;
